<template>
	<footer id="footer" style="bottom: 0; position: fixed; left: 120px; right: 35px" class="row">
		<p class="col-auto me-auto" style="display: flex; float: left; align-items: center; color: #737373">
			<i class="icon-logo-text" style="font-size: 22px; margin-right: 10px"></i>
			copyright &copy; <span class="date">{{ "today date" }}</span>
		</p>
		<p class="col-auto" style="float: right"><a href="https://www.dynvibe.com" rel="external">www.dynvibe.com</a></p>
	</footer>
</template>

<script>
export default {};
</script>

<style></style>
